import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { AutoCompleteItem, Dropdown } from "@/components/Dropdown/Dropdown";

import { DraftReplies } from "@/enum/draft-replies.enum";
import { useTour } from "@/components/Tour/useTour";

type DraftRepliesSectionProps = {
	value: DraftReplies | null;
	onChange: (value: DraftReplies) => void;
};

export const DraftRepliesSection: FunctionComponent<DraftRepliesSectionProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`copywritingSettings.draftReplies.${key}`);
	const { startPendingTour } = useTour();

	useEffect(() => {
		startPendingTour("draft-replies-settings");
	}, [startPendingTour]);

	const options: AutoCompleteItem[] = [
		{ id: DraftReplies.NONE, title: ts("options.none") },
		{ id: DraftReplies.ONE, title: ts("options.one") },
		{ id: DraftReplies.THREE, title: ts("options.three") },
	];

	return (
		<div className="rounded-xl border border-border-light bg-brand-white p-4">
			<h3 className="text-smd font-medium text-text mb-1">{ts("title")}</h3>
			<p className="text-xs text-text-meta mb-3">{ts("description")}</p>

			<div className="flex flex-col gap-1 w-full" data-tour="draft-replies-dropdown">
				<Dropdown
					data={options}
					defaultValue={value ? options.find((o) => o.id === value) : undefined}
					floating={true}
					handleSelect={(selected?: AutoCompleteItem) => {
						if (selected?.id) {
							onChange(selected.id as DraftReplies);
						}
					}}
					information={ts("information")}
					label={ts("label")}
				/>
			</div>
		</div>
	);
};
